import { Venue } from "../../../models";
import { Component, OnInit, OnDestroy } from '@angular/core';
import { Store } from '@ngrx/store';
import { AppState } from "../../../reducers";
import { VenueActions } from "../venue.actions"
import { PaginationConfig } from "../../../services"
import { ActivatedRoute, Router } from '@angular/router';

@Component({
	selector: 'venue-list',
	templateUrl: "./venue-list.html",
	styles: [require("./venue-list.scss")]
})


export class VenueListComponent implements OnInit {
	venues: Venue[]
	displayName: string = ""
	displayCity: string = ""
	displayPostalCode: string = ""

	private searchSort: string = "name,asc"
	private searchName: string = ""
	private searchCity: string = ""
	private searchPostalCode: string = ""

	private paginationConfig: PaginationConfig

	private venuesSubscribe;
	private paginationConfigSubscribe;
	private paramsSubscribe;

	constructor(
		private store$: Store<AppState>,
		private venueActions: VenueActions,
		private route: ActivatedRoute,
		private router: Router
	) { }

	ngOnInit() {
		// TODO presentation layer einfuegen, dann koennen venues und paginationConfig mit async im template aufgeloest werden
		// und es muss nicht explizit in ngOnDestroy unsubscribed werden
		this.venuesSubscribe = this.store$.select("venuesState", "venues").subscribe(venues => this.venues = venues)
		this.paginationConfigSubscribe = this.store$.select("venuesState", "paginationConfig")
												.subscribe(paginationConfig => this.paginationConfig = paginationConfig)

		this.paramsSubscribe = this.route.params.subscribe(params => {
			if (Object.keys(params).length > 0) {
				this.displayName = params["name"]
				this.displayCity = params["city"]
				this.displayPostalCode = params["postalCode"]

				this.searchName = params["name"]
				this.searchCity = params["city"]
				this.searchPostalCode = params["postalCode"]

				this.searchVenues(
					params["size"],
					params["page"],
					params["sort"],
					params["name"],
					params["city"],
					params["postalCode"]
				)
			} else {
				this.displayName = ""
				this.displayCity = ""
				this.displayPostalCode = ""

				this.searchName = ""
				this.searchCity = ""
				this.searchPostalCode = ""

				this.initialSearch()
			}
		})
	}

	ngOnDestroy() {
		this.venuesSubscribe.unsubscribe()
		this.paginationConfigSubscribe.unsubscribe()
		this.paramsSubscribe.unsubscribe()
	}

	public search(name: string, city: string, postalCode: string) {
		this.searchName = name
		this.searchCity = city
		this.searchPostalCode = postalCode

		this.router.navigate(["/venues", {
				size: this.paginationConfig.itemsPerPage,
				page: 0,
				sort: this.searchSort,
				name: this.searchName,
				city: this.searchCity,
				postalCode: this.searchPostalCode
			}])
	}

	public initialSearch() {
		this.paginationConfig.currentPage = 0
		this.searchVenues(
			this.paginationConfig.itemsPerPage,
			this.paginationConfig.currentPage,
			this.searchSort,
			this.searchName,
			this.searchCity,
			this.searchPostalCode)
	}

	public resetSearch() {
		this.displayName = ""
		this.displayCity = ""
		this.displayPostalCode = ""
		this.searchName = ""
		this.searchCity = ""
		this.searchPostalCode = ""

		this.router.navigate(["/venues"])
	}

	pageChanged(pageNumber: number) {
		this.paginationConfig.currentPage = pageNumber - 1;
		this.router.navigate(["/venues", {
				size: this.paginationConfig.itemsPerPage,
				page: this.paginationConfig.currentPage,
				sort: this.searchSort,
				name: this.searchName,
				city: this.searchCity,
				postalCode: this.searchPostalCode
			}])
	}

	private searchVenues(size: number, page: number, sort: string, name: string, city: string, postalCode: string) {
		this.store$.dispatch(this.venueActions.searchVenues({
			size: size,
			page: page,
			sort: sort,
			name: name,
			city: city,
			postalCode: postalCode
		}))
	}
}



// WEBPACK FOOTER //
// ./src/app/components/venue-components/venue-list/venue-list.component.ts